"use client";

import {
  logEvent as firebaseLogEvent,
  setUserId,
  setUserProperties,
} from "firebase/analytics";

import { analytics } from "@/lib/firebase";

/**
 * Log a custom event to Firebase Analytics
 * Only works in browser environment
 */
export const logEvent = (
  eventName: string,
  eventParams?: Record<string, unknown>,
) => {
  if (analytics && typeof window !== "undefined") {
    firebaseLogEvent(analytics, eventName, eventParams);
  }
};

/**
 * Log page view event
 */
export const logPageView = (pagePath: string, pageTitle?: string) => {
  if (analytics && typeof window !== "undefined") {
    firebaseLogEvent(analytics, "page_view", {
      page_path: pagePath,
      page_title: pageTitle || document.title,
    });
  }
};

/**
 * Log user login event
 */
export const logLogin = (method: string) => {
  if (analytics && typeof window !== "undefined") {
    firebaseLogEvent(analytics, "login", {
      method,
    });
  }
};

/**
 * Log user signup event
 */
export const logSignup = (method: string) => {
  if (analytics && typeof window !== "undefined") {
    firebaseLogEvent(analytics, "sign_up", {
      method,
    });
  }
};

/**
 * Set user ID for analytics
 */
export const setAnalyticsUserId = (userId: string) => {
  if (analytics && typeof window !== "undefined") {
    setUserId(analytics, userId);
  }
};

/**
 * Set user properties for analytics
 */
export const setAnalyticsUserProperties = (
  properties: Record<string, unknown>,
) => {
  if (analytics && typeof window !== "undefined") {
    setUserProperties(analytics, properties);
  }
};

/**
 * Log tournament-related events
 */
export const logTournamentEvent = (
  action: "create" | "view" | "edit" | "delete",
  tournamentId?: string,
) => {
  if (analytics && typeof window !== "undefined") {
    firebaseLogEvent(analytics, `tournament_${action}`, {
      tournament_id: tournamentId,
    });
  }
};

/**
 * Log match-related events
 */
export const logMatchEvent = (
  action: "create" | "view" | "edit" | "complete" | "walkover",
  matchId?: string,
) => {
  if (analytics && typeof window !== "undefined") {
    firebaseLogEvent(analytics, `match_${action}`, {
      match_id: matchId,
    });
  }
};

/**
 * Log team-related events
 */
export const logTeamEvent = (
  action: "create" | "view" | "edit" | "delete",
  teamId?: string,
) => {
  if (analytics && typeof window !== "undefined") {
    firebaseLogEvent(analytics, `team_${action}`, {
      team_id: teamId,
    });
  }
};
